import { useQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { DataLoader } from "../../../components";
import { EmptyContainer, ErrorContainer, SuccessContainer } from "../../../components/DataLoader";
import { EmptyContainer as Empty } from "../../../components/ui/EmptyContainer";
import type { AccountQuery, AccountQueryVariables } from "../../../graphql/types";
import { AccountDetail as AccountDetailType, AccountDocument } from "../../../graphql/types";
import { AppError } from "../../../pages/static/AppError";
import { AccountData } from "../components/AccountData/AccountData";

const AccountDetailsPage = () => {
  const { url_name } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState({
    roles: searchParams.get("roles")?.split(",") || null,
    nameOrEmail: searchParams.get("nameOrEmail") || null,
  });

  useEffect(() => {
    const { roles, nameOrEmail } = filter;
    const { currentTab } = Object.fromEntries([...searchParams]);
    // We only need to preserve the currentTab
    setSearchParams({
      ...(currentTab
        ? { currentTab }
        : {
            currentTab: "users",
          }),
      ...(roles ? { roles: roles.join(",") } : []),
      ...(nameOrEmail ? { nameOrEmail } : {}),
    });
  }, [filter, searchParams, setSearchParams]);

  const { loading, error, data } = useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, {
    variables: {
      urlName: url_name ?? "",
    },
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  return (
    <Stack
      sx={{
        paddingX: "132px",
      }}
    >
      <DataLoader loading={loading} error={error} success={Boolean(data?.account)}>
        <EmptyContainer>
          <Empty title="No Data" />
        </EmptyContainer>
        <ErrorContainer>
          <AppError />
        </ErrorContainer>
        <SuccessContainer>
          <AccountData account={data?.account as AccountDetailType} filter={filter} setFilter={setFilter} />
        </SuccessContainer>
      </DataLoader>
    </Stack>
  );
};

export { AccountDetailsPage };
